import * as React from "react";
import { ActionButton, IButtonStyles, IIconProps, TooltipHost } from "@fluentui/react";
import { LanguageContext } from "../../../../utilities/LocalizationModule";
import { iconStyles } from "../../styles/iconStyles";

const refreshIcon: IIconProps = {
  iconName: "refresh",
  styles: iconStyles
};

const actionButtonStyles: IButtonStyles = {
  root: { padding: 0, height: 25 }
}

interface SubTitleRefreshButtonProps {
  onClick: () => void;
}

const SubTitleRefreshButton: React.FunctionComponent<SubTitleRefreshButtonProps> = ({
  onClick,
}: SubTitleRefreshButtonProps) => {
  const languageStrings = React.useContext(LanguageContext);
  return (
    <TooltipHost content={languageStrings.Refresh}>
      <ActionButton
        iconProps={refreshIcon}
        styles={actionButtonStyles}
        allowDisabledFocus
        onClick={(event) => {
          event.stopPropagation();
          onClick();
        }}
      />
    </TooltipHost>
  );
};

export default SubTitleRefreshButton;